import { Link } from 'react-router';
import { AlertCircle, RefreshCw } from 'lucide-react';
import './ErrorState.css';

type ErrorStateProps = {
  title?: string;
  message: string;
  onRetry?: () => void;
  backTo?: { label: string; to: string };
  action?: { label: string; onClick: () => void };
  compact?: boolean;
};

export function ErrorState({ title = 'Something went wrong', message, onRetry, backTo, action, compact }: ErrorStateProps) {
  const hasActions = onRetry || backTo || action;

  return (
    <div className={`error-state-shared${compact ? ' compact' : ''}`}>
      <div className="error-state-icon-wrap">
        <AlertCircle className="error-state-icon" />
      </div>
      <span className="error-state-eyebrow">Error</span>
      <h3 className="error-state-title">{title}</h3>
      <p className="error-state-message">{message}</p>
      {hasActions && (
        <div className="error-state-actions">
          {onRetry && (
            <button type="button" className="error-state-retry" onClick={onRetry}>
              <RefreshCw size={13} />
              Try again
            </button>
          )}
          {backTo && (
            <Link to={backTo.to} className="error-state-back">
              {backTo.label}
            </Link>
          )}
          {action && (
            <button type="button" className="error-state-action" onClick={action.onClick}>
              {action.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
